/**
 * Routage + garde auth/onboarding. Flux : non connecté → /login ; connecté sans
 * profil → /onboarding ; connecté avec profil → dashboards.
 */
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { useProfile } from '@/hooks/queries';
import { useAuth } from '@/lib/auth';
import { AnalysePage } from '@/pages/AnalysePage';
import { AnnexesPage } from '@/pages/AnnexesPage';
import { CaloriesPage } from '@/pages/CaloriesPage';
import { DataPage } from '@/pages/DataPage';
import { ExercisePage } from '@/pages/ExercisePage';
import { FoodsPage } from '@/pages/FoodsPage';
import { HomePage } from '@/pages/HomePage';
import { HydrationPage } from '@/pages/HydrationPage';
import { JournalPage } from '@/pages/JournalPage';
import { LoginPage } from '@/pages/LoginPage';
import { MacrosPage } from '@/pages/MacrosPage';
import { OnboardingPage } from '@/pages/OnboardingPage';
import { ProfilePage } from '@/pages/ProfilePage';
import { WeightPage } from '@/pages/WeightPage';

export function App() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace state={{ from: location }} />} />
      </Routes>
    );
  }

  return <AuthenticatedApp />;
}

/** Sous-app affichée une fois connecté (le profil conditionne l'onboarding). */
function AuthenticatedApp() {
  const { data: profile, isLoading } = useProfile();

  if (isLoading) {
    return <div className="center-screen">Chargement…</div>;
  }

  if (!profile) {
    return (
      <Routes>
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="*" element={<Navigate to="/onboarding" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="/poids" element={<WeightPage />} />
        <Route path="/calories" element={<CaloriesPage />} />
        <Route path="/macros" element={<MacrosPage />} />
        <Route path="/hydratation" element={<HydrationPage />} />
        <Route path="/sport" element={<ExercisePage />} />
        <Route path="/analyse" element={<AnalysePage />} />
        <Route path="/journal" element={<JournalPage />} />
        <Route path="/foods" element={<FoodsPage />} />
        <Route path="/data" element={<DataPage />} />
        <Route path="/annexes" element={<AnnexesPage />} />
        <Route path="/profile" element={<ProfilePage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
